import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=1d04402e&scoped=true&lang=html"
import script from "./FileBrowser.vue?vue&type=script&lang=js"
export * from "./FileBrowser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d04402e",
  null
  
)

export default component.exports